const COOKIE_NAME = 'gam_handoff';

/** The owner rides along with the code so switching account cannot hand over the previous one. */
export interface ParkedHandoff {
  userId: string;
  code: string;
}

export function readHandoffCookie(): ParkedHandoff | null {
  const entry = document.cookie.split('; ').find((candidate) => candidate.startsWith(`${COOKIE_NAME}=`));
  if (!entry) return null;

  const value = decodeURIComponent(entry.slice(COOKIE_NAME.length + 1));
  const separator = value.indexOf(':');
  if (separator < 1) return null;

  return { userId: value.slice(0, separator), code: value.slice(separator + 1) };
}

/** `expiresIn` comes from the server so the cookie cannot outlive the code it carries. */
export function writeHandoffCookie(parked: ParkedHandoff, expiresInMs: number): void {
  const secure = window.location.protocol === 'https:' ? ';Secure' : '';
  const value = encodeURIComponent(`${parked.userId}:${parked.code}`);
  const maxAge = Math.floor(expiresInMs / 1000);
  document.cookie = `${COOKIE_NAME}=${value};path=/;max-age=${maxAge};SameSite=Lax` + secure;
}

export function clearHandoffCookie(): void {
  document.cookie = `${COOKIE_NAME}=;path=/;max-age=0;SameSite=Lax`;
}
